import { render, staticRenderFns } from "./payChannelReport.vue?vue&type=template&id=5772a1f3&scoped=true&"
import script from "./payChannelReport.vue?vue&type=script&lang=js&"
export * from "./payChannelReport.vue?vue&type=script&lang=js&"
import style0 from "./payChannelReport.vue?vue&type=style&index=0&id=5772a1f3&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5772a1f3",
  null
  
)

export default component.exports